<div class="amount-selector">
  <div class="amount-selector__switcher">
    @for (amount of options(); track amount; let i = $index) {
      <button
        class="amount-selector__switcher-button"
        [disabled]="isDisabled()"
        [class.active]="value() === amount && !isCustomAmountActive()"
        (click)="onSelectAmount(amount)"
      >
        @if (type() === AmountSelectorType.Fixed) {
          {{ amount | currency: 'USD' : '$' : '1.0-2' }}
        } @else if (type() === AmountSelectorType.Percent) {
          {{ amount }}%
        }
      </button>
    }

    @if (isCustomAmountVisible()) {
      <button
        class="amount-selector__switcher-button"
        [disabled]="isDisabled()"
        [class.active]="isCustomAmountActive()"
        (click)="onSelectCustomAmount()"
      >
        Other
      </button>
    }
  </div>

  @if (isCustomAmountActive()) {
    <div @slideInOut class="amount-selector__custom custom-amount">
      <div class="custom-amount__control">
        <input
          type="number"
          class="custom-amount__control-input"
          placeholder="Type your custom amount"
          [(ngModel)]="value"
          (ngModelChange)="onCustomAmountChange($event)"
        />
      </div>

      <span class="custom-amount__value">
        @if (type() === AmountSelectorType.Fixed) {
          {{ value() | currency: 'USD' : '$' : '1.0-2' }}
        } @else if (type() === AmountSelectorType.Percent) {
          {{ value() }}%
        }
      </span>
    </div>
  }
</div>
